import { createContext, useContext, useState, useMemo } from "react";
import { Dispatch, SetStateAction } from "react";

type ProductDetailsContextValue = {
  showOriginalText: boolean;
  setShowOriginalText: Dispatch<SetStateAction<boolean>>;
};

const ProductDetailsContext = createContext<ProductDetailsContextValue>(
  {} as ProductDetailsContextValue
);

const ProductDetailsProvider = ({
  children,
}: {
  children?: React.ReactNode;
}) => {
  const [showOriginalText, setShowOriginalText] = useState<boolean>(false);

  const value = useMemo(
    () => ({ showOriginalText, setShowOriginalText }),
    [setShowOriginalText, showOriginalText]
  );

  return (
    <ProductDetailsContext.Provider value={value}>
      {children}
    </ProductDetailsContext.Provider>
  );
};

export const useProductDetailsContext = () => {
  return useContext(ProductDetailsContext);
};

export default ProductDetailsProvider;
